import { authState } from "@shared/states/authState";
import { RegionV4 } from "@shared/types/riot";

const BASE_URL = import.meta.env.VITE_API_URL;
const RIOT_URL = import.meta.env.VITE_RIOT_API_URL;

export interface RSOToken {
	token: string;
	expires_at: string;
	region: RegionV4;
}

export type RSOTokenResponse = {
	ok: boolean;
} & RSOToken;

export async function fetchRSOToken(): Promise<RSOTokenResponse> {
	const res = await fetch(`${BASE_URL}/rso/token`, {
		method: "GET",
		headers: { Authorization: "Bearer " + authState.accessToken },
	});

	return await res.json();
}

export interface RSOAccount {
	gameName: string;
	tagLine: string;
	puuid: string;
}

export type RSOAccountResponse = {
	ok: boolean;
} & RSOAccount;

export async function fetchRSOAccount(rsoToken: string): Promise<RSOAccountResponse> {
	const res = await fetch(`${RIOT_URL}/rso/account/europe/me`, {
		method: "GET",
		headers: { "X-Riot-Token": rsoToken },
	});

	return res.json();
}

export async function fetchRSOSummoner(
	rsoToken: string,
	region: RegionV4,
): Promise<RSOAccountResponse> {
	const res = await fetch(`${RIOT_URL}/rso/summoner/${region}/me`, {
		method: "GET",
		headers: { "X-Riot-Token": rsoToken },
	});

	return res.json();
}

export async function logoutRSO(): Promise<{ ok: boolean }> {
	const res = await fetch(`${BASE_URL}/rso/logout`, {
		method: "GET",
		headers: { Authorization: "Bearer " + authState.accessToken },
	});

	return await res.json();
}
